<template>
  <div
    v-if="list.length"
    id="scrollDIV"
    class="home-banner"
  >
    <div class="swiper-container">
      <div class="swiper-wrapper swiper-wrapper-holder">
        <a
          v-for="(item, index) in list"
          :key="index"
          class="swiper-slide home-banner-img"
          :href="item.link"
          :uigs="`out_home_big_video_${index}`"
          :data-report="JSON.stringify({ home_banner_click: list[activeIndex].title })"
        >
          <img-item
            :src="item.img_url"
            :lazy="index === 0 ? false : true"
          />
          <h4>{{ item.name }}</h4>
        </a>
      </div>
    </div>
    <div
      v-if="list.length > 1"
      class="home-banner-btn"
    >
      <span
        v-for="(item, index) in list"
        :key="index"
        :class="{ cur: index === 0 }"
      />
    </div>
  </div>
</template>

<script>
import '../../../asset/css/vendors/swiper.css';

import { mapState } from 'vuex';

import { getSsrUigsParams } from '../../common/js/util';
import ImgItem from './ImgItem';

export default {
  components: {
    ImgItem,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      uigsParams: {},
      activeIndex: 0,
    };
  },
  computed: {
    ...mapState('common', ['$config']),
  },
  mounted() {
    const self = this;
    const Swiper = require('../../../asset/js/swiper');

    // banner埋点上报
    const params = getSsrUigsParams();
    const { $config = {} } = self;
    self.uigsParams = {
      ...params,
      is_na: $config.isNa,
      is_mix: $config.iskd || 0,
      hitkd: $config.isHitKd,
      qua: $config.qua || '',
      guid: $config.guid,
      pagetype: 'home_promotion',
    };

    self.$nextTick(() => {
      if (self.list.length < 2) {
        return;
      }
      new Swiper('.swiper-container', {
        autoplay: {
          autoplay: 3000,
          disableOnInteraction: false,
        },
        loop: true,
        pagination: {
          el: '.home-banner-btn',
        },
        on: {
          slideNextTransitionStart() {
            const index = this.activeIndex > self.list.length ? 1 : this.activeIndex;
            self.activeIndex = index - 1;
            self.$emit('change', index - 1);
          },
          slidePrevTransitionStart() {
            const index = this.activeIndex < 1 ? self.list.length : this.activeIndex;
            self.activeIndex = index - 1;
            self.$emit('change', index - 1);
          },
          slideChangeTransitionEnd() {
            const { list, activeIndex } = self;
            self.$uigsKd.send({
              ...self.uigsParams,
              home_banner: list[activeIndex].title,
            });
          },
        },
      });
    });
  },
};
</script>

<style lang="scss">
@import '../../../asset/css/abstracts/mixin.scss';
@import '../../../asset/css/abstracts/function_sprite_home.scss';

.home-banner {
  overflow: hidden;
  position: relative;
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);
}
.swiper-container {
  height: 100%;
  border-radius: 5px;

  .swiper-wrapper-holder {
    height: 188px;
  }
}

.home-banner-img {
  width: 100%;
  height: 188px;
  position: relative;
  h4 {
    width: 75%;
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 7px 14px;
    height: 21px;
    z-index: 20;
    color: #fff;
    font-weight: 500;
    line-height: 21px;
    font-size: 15px;

    @include line-clip(1);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  &:after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 39px;
    z-index: 10;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);
  }

  .img-default-sogou:before, .img-default-film:before {
    display: none;
  }
}

@media screen and (min-width: 400px) {
  .home-banner-img {
    height: 200px;
  }

  .swiper-wrapper-holder {
    height: 200px !important;
  }
}

.home-banner-btn {
  position: absolute;
  right: 15px;
  bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  z-index: 20;

  .swiper-pagination-bullet {
    opacity: 1;
  }

  span {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.4);
    margin-right: 4px;
    &.swiper-pagination-bullet-active {
      background: #fff;
    }
  }
}
</style>
